export enum OrderInternalStatusDetails {
  LateNotification = 'late_notification',
  MissedTemplate = 'missed_template',
}
